export default __webpack_public_path__ + "static/media/section-our-values.92ad023a.svg";